module.exports = __webpack_public_path__ + "static/media/timelapse_2.f5917ec7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_2.jpg
// module id = 962
// module chunks = 0